import { action, computed, makeObservable, runInAction } from "mobx";
import { MrbBaseListViewStore } from "mrb/core";
import { MrbGridViewStore } from "mrb/components/grid";
import { find } from "lodash";

class UserStationExpirationViewStore extends MrbBaseListViewStore {
    get userId() {
        return this.userContentExpirationViewStore.userId;
    }

    @computed get isInitalized() {
        return this.gridStore.dataInitialized;
    }

    constructor(rootStore, userContentExpirationViewStore) {
        super(rootStore, {
            queryConfig: {
                disableUpdateQueryParams: true,
            },
        });
        makeObservable(this);
        this.userContentExpirationViewStore = userContentExpirationViewStore;
        this.routeStore = this.userContentExpirationViewStore.routeStore;

        this.setGridStore(
            new MrbGridViewStore(this.rootStore, this.queryUtility, {
                generateKey: (item) => item.stationId,
            })
        );

        this.reaction(
            () => this.queryUtility.filter.search,
            () => {
                this.queryUtility.fetch();
            },
            {
                delay: 300,
            }
        );
    }

    find(params) {
        params.userId = this.userId;
        return this.routeStore.findUserStationExpiration(params);
    }

    @action.bound
    async createExpirationDate(stationId, value) {
        const station = find(this.gridStore.data, (item) => item.stationId === stationId);
        if (station) {
            try {
                this.rootStore.mainLoaderStore.suspend();
                const data = {
                    stationId: station.stationId,
                    userId: this.userId,
                    expirationDate: value,
                };
                const item = await this.routeStore.createUserStationExpiration(data);
                runInAction(() => {
                    station.userStationExpirationId = item.id;
                    station.expirationDate = value;
                });
            } catch (err) {
                this.rootStore.notificationStore.error(
                    "An unexpected error occurred while trying to update station expiration date. Please contact the support team."
                );
            } finally {
                this.rootStore.mainLoaderStore.resume();
            }
        }
        return station;
    }

    @action.bound
    async updateExpirationDate(stationId, value) {
        const station = find(this.gridStore.data, (item) => item.stationId === stationId);
        if (station) {
            try {
                this.rootStore.mainLoaderStore.suspend();
                const data = {
                    id: station.userStationExpirationId,
                    stationId: station.stationId,
                    userId: this.userId,
                    expirationDate: value,
                };
                await this.routeStore.updateUserStationExpiration(data);
                runInAction(() => {
                    station.expirationDate = value;
                });
            } catch (err) {
                this.rootStore.notificationStore.error(
                    "An unexpected error occurred while trying to update station expiration date. Please contact the support team."
                );
            } finally {
                this.rootStore.mainLoaderStore.resume();
            }
        }
        return station;
    }

    @action.bound
    async deleteExpirationDate(stationId) {
        const station = find(this.gridStore.data, (item) => item.stationId === stationId);
        if (station) {
            try {
                this.rootStore.mainLoaderStore.suspend();
                await this.routeStore.deleteUserStationExpiration(station.userStationExpirationId);
                runInAction(() => {
                    station.userStationExpirationId = null;
                    station.expirationDate = null;
                });
            } catch (err) {
                this.rootStore.notificationStore.error(
                    "An unexpected error occurred while trying to update station expiration date. Please contact the support team."
                );
            } finally {
                this.rootStore.mainLoaderStore.resume();
            }
        }
        return station;
    }
}

export default UserStationExpirationViewStore;
